import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import REFINANCEIRQVaLoanBeforeView from "../views/IrqVaLoanBeforeView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object, bool } from "yup";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqVaLoanBeforePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            vaFirstTimeUse: bool().required(),
          })}
        >
          <REFINANCEIRQVaLoanBeforeView
            content={contentMap.RefinanceIrqVaLoanBeforePage}
            navigationsAway={customNavigationMap.RefinanceIrqVaLoanBeforePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqVaLoanBeforePage);
